import React from 'react';
import {LazyImage} from "../../../Components";
import {detectEnglishLang} from "../../../Services";

function ButtonListSec({item,LinkDispatcher}){


    return(
        <div style={{margin: "20px 16px 0 16px"}}>
            {item.title?<div className="section-title"><span>{item.title}</span></div>:null}
            <div className="digi_badg_actions" >
                {item.items.map(itemz => {
                    return (
                        <div key={itemz.uid} className="digi_badg_actions_item"
                             onClick={() => {
                                 LinkDispatcher(itemz.link_to, itemz)
                             }}>
                            <img src={itemz.image} alt="" style={{width: 60}}/>
                            <span
                                className={detectEnglishLang(itemz.title) ? "eng-title" : "per-title"}>{itemz.title}</span>
                        </div>
                    )
                })}
            </div>
        </div>
            )
}

export default ButtonListSec
